<template>
    
    <Row class="g2-s">
        <Col :span="colSpan" v-for="(el, i) in list" :key="i">
            <div class="g2-s-name">{{el.name}}</div>
            <div class="g2-s-money">{{el.value}}</div>
        </Col>
    </Row>
</template>
<script>
    /**
     * 图表最上面的统计部分
     */
    export default {
        props: {
            list: {
                type: Array,
                default: () => new Array()
            }
        },
        computed: {
            colSpan () {
                return parseInt(24 / this.list.length)
            }
        }
    }
</script>

<style>
    .g2-s {
        padding-bottom: 20px;
    }
    .g2-s-name {
        font-size: 14px;
    }
    .g2-s-money {
        font-size: 24px;
        margin-top: 5px;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/g2-chart/src/statistic.vue